import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
  selector: 'kv-promo-template-detail',
  template: `
    <div class="Customers customer-company ui-g">
      <div class="ui-g ui-fluid" style="width: 100%">
        <div class="ui-g-12">
          <div>
            <div class="ui-g ui-g-nopad form-group master-data">
              <div class="ui-g-12 ui-lg-8 ui-g-nopad">
                <h1 class="step-title">{{ titlePage | translate}}</h1>
              </div>
              <div class="ui-g-12 ui-lg-4 text-right">
                <button
                  pButton
                  type="button"
                  class="k-generic-btn"
                  icon="fa fa-angle-left"
                  iconPos="left" label="Back"
                  (click)="locationBack()">
                </button>
                <button
                  pButton
                  type="button"
                  class="k-generic-btn"
                  icon="fa fa-floppy-o"
                  iconPos="left"
                  label="{{ 'common.save' | translate }}"
                  (click)="save()">
                </button>
              </div>
            </div>
          </div>
          <form *ngIf="formData" [formGroup]="formData">
            <div class="ui-g form-group master-data">
              <div [kv-form-element]="{ label: 'promotion.code', md: '4' }">
                <input
                  type="text"
                  pInputText
                  formControlName="code" />
              </div>
              <div [kv-form-element]="{ label: 'promotion.description', md: '4' }">
                <input
                  type="text"
                  pInputText
                  formControlName="description" />
              </div>
              <div [kv-form-element]="{ label: 'promotion.typeTemplate', md: '4' }">
                <p-inputSwitch formControlName="flg_type_template"></p-inputSwitch>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>`
})
export class TemplateDetailComponent implements OnInit {

  @Input() template;
  @Input() titlePage;
  @Output() hide = new EventEmitter();
  @Output() saveTemplate = new EventEmitter();

  formData: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.createForm();
  }

  locationBack() {
    this.hide.emit();
  }

  save() {
    if (!this.template.id) {
      /*Creazione nuovo template*/
      this.saveTemplate.emit({
        code: this.formData.controls['code'].value,
        description: this.formData.controls['description'].value,
        flg_type_template: this.formData.controls['flg_type_template'].value
      })
    }else {
      /*Modifica template esistente*/
      this.saveTemplate.emit({
        id: this.template.id,
        code: this.formData.controls['code'].value,
        description: this.formData.controls['description'].value,
        flg_type_template: this.formData.controls['flg_type_template'].value
      })
    }
  }

  createForm() {
    this.formData = this.fb.group({
      'code': this.template.code,
      'description': this.template.description,
      'flg_type_template': this.template.flg_type_template
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/template/components/templateDetail.component.ts